import * as React from "react";
import {cx} from "emotion";

import "./mask-editing.scss";

import {cs}            from "@Common/react/chain-services";
import {DebounceCache} from "@Common/react/debounce-cache";
import {defaultState}  from "@Common/react/default-state";
import {scopedState}   from "@Common/react/scoped-state";

import {Checkbox}        from "../../../../heavy/common/design2/checkbox/checkbox";
import {OpacitySelector} from "../../../common/opacity-selector/opacity-selector";

export const MaskEditing = ({mobile, state, onCutout}) => cs(
    () => (
        <div className={cx("mask-editing mask-editing-3jg", {mobile})}>
            {cs(
                ["debounce", (_, next) => DebounceCache({
                    state: scopedState(state, ["opacity"]),
                    delay: 100,
                    next,
                })],
                ({debounce}) => OpacitySelector({
                    state: defaultState(debounce.state, () => .5),
                })
            )}

            {state.value?.url && (
                <a {...{
                    className: "cutout",
                    onClick: () => onCutout(!state.value.maskCutout),
                }}>
                    <div className="label">
                        Cut out
                    </div>
                    {Checkbox({
                        checked: state.value.maskCutout,
                        size: "small",
                    })}
                </a>
            )}
        </div>
    ),
);
